export default {
      id: "circle-o-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#circle-o",
      toString: function () {
        return this.url;
      }
    }